import { render } from "./DashboardSpecialPricing.vue?vue&type=template&id=428e1a32"
import script from "./DashboardSpecialPricing.vue?vue&type=script&lang=js"
export * from "./DashboardSpecialPricing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__